import Link from 'next/link';
import { useRouter } from 'next/router';
import type { FC } from 'react';
import { Button } from '@/DesignSystem/Component';
import { LINKS } from '@/Module/Core/Constant';
import { useDeviceType } from '@/Module/Core/Hook';
import { DeviceType } from '@/Module/Core/Model/Enum';
import { IconExclamationMark, IconExclamationMarkMobile } from '@/Module/Icon';
import { lessonSectionSetActiveTabNumber } from '@/Module/Lesson/Store/Slice/LessonSectionSlice';
import { useAppDispatch } from '@/Module/Store/Hook';
interface ILessonSubscriptionBlurProps {
  type?: 'handout' | 'exam';
}
const LessonSubscriptionBlur: FC<ILessonSubscriptionBlurProps> = ({
  type
}) => {
  const router = useRouter();
  const deviceType = useDeviceType();
  const redirectLink = `${LINKS.SUBSCRIPTION.MAIN}?redirectUrl=${encodeURI(router.asPath)}`;
  const dispatch = useAppDispatch();
  // const relatedSubscriptionId = useAppSelector(state => state.lessonSection.relatedSubscriptionId);

  // const subscriptionLink = useMemo(() => {
  //   if (!relatedSubscriptionId) return '';
  //   return `${LINKS.SUBSCRIPTION.MAIN}/${relatedSubscriptionId}`;
  // }, [relatedSubscriptionId]);

  const clickHandler = () => {
    dispatch(lessonSectionSetActiveTabNumber(1));
  };
  const icon = deviceType === DeviceType.MOBILE ? <IconExclamationMarkMobile className="-mt-2 mb-5 " /> : <IconExclamationMark className="my-10" />;
  return <div className={`flex w-full flex-col items-center justify-center  ${type === 'handout' || type === 'exam' ? 'h fixed inset-0 z-[100]    bg-[#474A57F8] ' : 'absolute left-0 top-0 z-50  h-full   bg-[#474A57E1]'}`} data-sentry-component="LessonSubscriptionBlur" data-sentry-source-file="LessonSubscriptionBlur.tsx">
      {icon}

      <p className="leading-7 lg:leading-10 mb-3 max-w-[296px] text-center text-lg font-black text-[#FFBD12] lg:mb-7 lg:max-w-[500px] lg:text-2xl ">
        آی‌نویی عزیز، شما اشتراک فعالی ندارید، برای خرید اشتراک روی دکمه زیر کلیک کن.
      </p>

      <div className="mt-2 flex flex-row gap-4">
        <Button as={Link} href={redirectLink} variant="shadow" color="primary" radius="circle" size="small" className="text-sm font-black lg:h-[56px] lg:w-[254px]" data-sentry-element="Button" data-sentry-source-file="LessonSubscriptionBlur.tsx">
          خرید اشتراک
        </Button>
        {/* TODO: uncomment this when this button is desired by Product team! */}
        {/* {subscriptionLink.length > 1 ? ( */}
        {/*  <Button */}
        {/*    as={Link} */}
        {/*    href={subscriptionLink} */}
        {/*    variant="shadow" */}
        {/*    color="primary" */}
        {/*    radius="circle" */}
        {/*    size="small" */}
        {/*    className="text-sm font-black lg:h-[56px] lg:w-[254px]"> */}
        {/*    خرید این درس */}
        {/*  </Button> */}
        {/* ) : ( */}
        {/*  '' */}
        {/* )} */}
        {type === 'handout' || type === 'exam' ? <Button as="a" onClick={clickHandler} variant="shadow" color="orangeMiddle" radius="circle" size="small" className="cursor-pointer text-sm font-black">
            بعدا
          </Button> : ''}
      </div>
    </div>;
};
export default LessonSubscriptionBlur;